import React from 'react';
import Header from '../components/header/header';
import About from '../components/About/About';
import AboutUs from '../components/About-us/About-us';
import Features from '../components/Features/Features';
import Pricing from '../components/Pricing/Pricing';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';
import DotNavigation from '../components/DotNavigation/DotNavigation';

function Home() {
  return (
    <div className="App">
      <Header />  
      <DotNavigation />
      <div id="about">
        <About />
      </div>
      <div id="trusted">
        <AboutUs />
      </div>
      <div id="features">
        <Features />
      </div>
      <div id="pricing">
        <Pricing />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Footer/>
    </div>
  )
}

export default Home;